document.addEventListener('DOMContentLoaded', function () {
  var swipers = document.querySelectorAll('[data-media-swipe]');

  swipers.forEach(function (swiper) {
    var media = swiper.closest('.product-card__media');
    var dotsContainer = media ? media.querySelector('.product-card__media-dots') : null;
    var slides = swiper.querySelectorAll('.product-card__media-swipe-slide');

    if (!dotsContainer || slides.length < 2) return;

    var dots = dotsContainer.querySelectorAll('.product-card__media-dot');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
        });
      },
      { root: swiper, threshold: 0.6 }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  });
});
